import { isFeedieEmail } from '@feedyou/utils'

import { useUserInfo } from '../../../../../../../../store/user'
import { useFeature } from '../../../../../../../../store/features'

export function useIsArbitraryVersionSwitchingEnabled() {
  const userEmail = useUserInfo()?.email
  return useFeature('ALLOW_SETTING_ANY_HOSTING_VERSION') && isFeedieEmail(userEmail)
}
